/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { GoalAndInterventionDefinitionLibraryViewModel } from './GoalAndInterventionDefinitionLibraryViewModel'; 

export function getGoalAndInterventionDefinitionLibraryOptions(effectiveDate: string, onSuccess?: (result: GoalAndInterventionDefinitionLibraryViewModel) => void) {
	return queryOptions({
		queryKey: ['goal-and-intervention-definition-library', effectiveDate],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/careplanning/goalsandinterventions/definitions/queries/getgoalandinterventiondefinitionlibrary/' + '?effectiveDate=' + effectiveDate;
			const resp = await axios.get<GoalAndInterventionDefinitionLibraryViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(effectiveDate)
	});
}